// 表单校验
import Driver from "driver.js";
export const GoodsformCheck = { // 商品校验
    data() {
        return {
            checkform: {
                recGoodsState: [
                    { required: true, message: '请输入州' },
                ],
                recgoodscity: [
                    { required: true, message: '请输入市' },
                ],
                recwarehouseaddress: [
                    { required: true, message: '请输入详细地址' },
                ],
                recGoodsPostcode: [
                    { required: true, message: '请输入邮编' },
                    {
                        validator: (rule, value, callback) => {
                            if (value) {
                                const firstLetter = value.toString().substring(0,1)
                               if (this.privateAddressType == 3 && this.toFABck.namec !== firstLetter && this.toFABck.namec) {
                                return callback(new Error("邮政编码与目的地邮编首位不符"));
                               } else {
                                return callback()
                               }
                            } else {
                                return callback()
                            }
                        }
                    }
                ],
                recGoodsPerson: [
                    { required: true, message: '请输入联系人' }
                ],
                recGoodsTel: [
                    { required: true, message: '请输入联系电话',trigger: 'blur' }
                ],
            },
            checkBox: {
                preAllWeight: [
                    { required: true, message: "请输入总重量" },
                    {
                        validator: (rule, value, callback) => {
                            if (value.length > 15 || value.length < 1) {
                                callback(new Error("总重量请输入0到99999范围内的数,允许输入小数点后三位"));
                            } else {
                                var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
                                if (value <= 0) {
                                    callback(new Error("总重量必须大于0,请检查"));
                                }
                                if (!reg.test(value)) {
                                    callback(new Error("总重量必须大于0,请检查"));
                                } else {
                                    callback();
                                }
                            }
                        },
                        trigger: "change",
                    },
                ],
                preAllCbm: [
                    { required: true, message: "请输入总体积" },
                    {
                        validator: (rule, value, callback) => {
                            if (value.length > 15 || value.length < 1) {
                                callback(new Error("总体积请输入0到99999范围内的数,允许输入小数点后三位"));
                            } else {
                                var reg = /(^[1-9]\d*(\.\d{1,3})?$)|(^0(\.\d{1,3})?$)/;
                                if (value <= 0) {
                                    callback(new Error("总重量必须大于0,请检查"));
                                }
                                if (!reg.test(value)) {
                                    callback(new Error("总重量必须大于0,请检查"));
                                } else {
                                    callback();
                                }
                            }
                        },
                        trigger: "change",
                    },
                ],
                preBoxNum: [
                    { required: true, message: "请输入箱数" },
                    {
                        validator: (rule, value, callback) => {
                            if (value.length > 15 || value.length < 1) {
                                callback(new Error("箱数请输入1到99999范围内的数"));
                            } else {
                                var reg = /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/;
                                if (value <= 0) {
                                    callback(new Error("箱数请输入1到99999范围内的数"));
                                }
                                if (!reg.test(value)) {
                                    callback(new Error("箱数请输入1到99999范围内的数"));
                                } else {
                                    callback();
                                }
                            }
                        },
                        trigger: "change",
                    },
                ],

            },
        }
    },
    created: function () {

    },
    methods: {
        accAdd(arg1, arg2) {
            //加法精度
            var r1, r2, m;
            try {
                r1 = arg1.toString().split(".")[1].length;
            } catch (e) {
                r1 = 0;
            }
            try {
                r2 = arg2.toString().split(".")[1].length;
            } catch (e) {
                r2 = 0;
            }
            m = Math.pow(10, Math.max(r1, r2));
            return (arg1 * m + arg2 * m) / m;
        },
        getGudie() {
            this.driver = new Driver({
                className: "scoped-class", // className to wrap driver.js popover
                animate: true, // Animate while changing highlighted element
                opacity: 0.5, // Background opacity (0 means only popovers and without overlay)
                padding: 10, // Distance of element from around the edges
                // 点击其他区域是否关闭弹框： false：点击其他区域不关闭弹框 true：点击其他区域关闭弹框
                allowClose: false, // Whether clicking on overlay should close or not
                overlayClickNext: false, // Should it move to next step on overlay click
                doneBtnText: "我知道了", // Text on the final button
                closeBtnText: "跳过指引", // Text on the close button for this step
                nextBtnText: "下一步", // Next button text for this step
                prevBtnText: "上一步", // Previous button text for this step
                onHighlightStarted: (Element) => {
                    console.log("statrt")

                },
                onReset: (Element) => {
                    console.log('done');
                    localStorage.setItem("driverType5", false);
                },
            });
            let steps = [
                {
                    element: ".Itemshow1",
                    popover: {
                        title: `<div class="t11" style="display: flex;justify-content: space-between;font-size: 18px;">
                <div>输入地址信息</div>
                <div class="test1"></div>
              </div>`,
                        position: "right",
                    },
                    padding: 5,
                },
                {
                    element: ".Itemshow2",
                    popover: {
                        title: `<div class="t11" style="display: flex;justify-content: space-between;font-size: 18px;">
                <div>单击可选择上门取件或送货到仓</div>
                <div class="test1"></div>
              </div>`,
                    position: "right",
                    offset:-25
                    },
                    padding: 5,
                },
                {
                    element: ".Itemshow3",
                    popover: {
                        title: `<div class="t11" style="display: flex;justify-content: space-between;font-size: 18px;">
                <div>根据实际情况填写货物信息</div>
                <div class="test1"></div>
              </div>`,
                        position: "right",
                    },
                    padding: 5,
                },
                {
                    element: ".Itemshow4",
                    popover: {
                        title: `<div class="t11" style="display: flex;justify-content: space-between;font-size: 18px;">
                <div>单击提交订单按钮完成在线下单</div>
                <div class="test1"></div>
              </div>`,
                        position: "right",
                    },
                    padding: 5,
                },
            ];
            this.driver.defineSteps(steps);
            this.driver.start();
            this.driver.steps.forEach(el => el.node.style.pointerEvents = 'none')

            this.interval = setInterval(() => {
                if (!this.driver.isActivated) {
                    this.driver.steps.forEach(el => el.node.style.pointerEvents = 'auto')
                    clearInterval(this.interval)
                }
            }, 100)
        },
    },
    mounted() {

    }
}



// WEBPACK FOOTER //
// ./src/components/privateOrder/fromCheck.js